import classNames from "classnames";
import React, { memo } from "react";
import Styled from "./clickableArea.styled";
function ClickableArea(props) {
    return (React.createElement(Styled.Container, { blockWidth: props.width, blockHeight: props.height, bgColor: props.bgColor, borderColor: props.borderColor, bgColorHover: props.bgColorHover, bgColorActive: props.bgColorActive, borderColorHover: props.borderColorHover, borderColorActive: props.borderColorActive, className: classNames("p-1 clickable", props.className), onClick: props.onClick },
        React.createElement(Styled.Icon, { color: props.iconColor, className: classNames(props.icon, "font-h2") }),
        React.createElement("div", { className: "ml-1 overflow-hidden" },
            React.createElement("div", { className: "font-bold text-overflow-ellipsis", title: props.title }, props.title),
            props.description && (React.createElement("div", { className: "text-overflow-ellipsis text-muted nowrap font-h6", title: props.description }, props.description)))));
}
export default memo(ClickableArea);
ClickableArea.defaultProps = {
    width: 400,
    heigh: 70
};
